import { create } from "zustand";
import { persist } from "zustand/middleware";

import { ExpandableWrapperTitleCodes } from "~/common/utils/types/summariesExpandableIdsTypes";
import { PREVIEW_TITLE_CODES } from "../constants/SummariesExpandableIds";

interface setExpandedSectionsProps {
  code: (typeof PREVIEW_TITLE_CODES)[keyof typeof PREVIEW_TITLE_CODES];
  sections: string[];
}

export interface UsePreviewStoreProps {
  expandedSections: {
    [K in ExpandableWrapperTitleCodes]: string[];
  };
  setExpandedSections: ({ code, sections }: setExpandedSectionsProps) => void;
  patientId?: string;
  setPatientId(patientId: string): void;
  reset: () => void;
}

const defaultValues = {
  patientId: undefined,
  expandedSections: {
    [PREVIEW_TITLE_CODES.FUNCTIONAL_DOMAINS]: [],
    [PREVIEW_TITLE_CODES.HEALTH_HISTORY]: [],
    [PREVIEW_TITLE_CODES.PERSONAL_LIFE_HISTORY]: [],
  },
};

export const usePreviewStore = create<UsePreviewStoreProps>()(
  persist(
    (set) => ({
      ...defaultValues,
      setExpandedSections: ({ code, sections }: setExpandedSectionsProps) => {
        set((state) => ({
          expandedSections: {
            ...state.expandedSections,
            [code]: sections,
          },
        }));
      },

      setPatientId: (patientId: string) => {
        set(() => ({ patientId }));
      },
      reset: () => set(defaultValues),
    }),
    {
      name: "usePreviewStore",
    },
  ),
);
